module.exports = __webpack_public_path__ + "img/img_banner_purchase.252824c1.svg";